import { render, staticRenderFns } from "./TableFilterable.vue?vue&type=template&id=bb07081a"
import script from "./TableFilterable.vue?vue&type=script&lang=ts"
export * from "./TableFilterable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports